import angular from 'angular';
import PageLoaderService from './pageLoader.service';

let pageLoaderModule = angular.module('pageLoader', []).service('pageLoaderService', PageLoaderService);

export default pageLoaderModule;



// WEBPACK FOOTER //
// ./app/common/pageLoader/pageLoader.js